import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import AuthShell from '../components/layout/AuthShell';
import AlertMessage from '../components/ui/AlertMessage';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred while requesting the reset link.');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthShell title="Check your email" subtitle="The reset link is on its way">
        <AlertMessage msg={{
          type: 'success',
          text: 'If an account exists with that email address, we have sent a password reset link to it. The link is valid for 30 minutes.',
        }} />
        <p className="text-sm text-gray-500 mb-6 leading-relaxed">
          Didn't get anything? Check your spam folder, or make sure you used the email address
          you registered with.
        </p>
        <Link to="/login" className="btn-primary w-full py-3">Back to sign in</Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title="Forgot password"
      subtitle="We'll email you a link to set a new one"
      footer={
        <p className="text-sm text-gray-500">
          Remembered it? <Link to="/login" className="link">Sign in</Link>
        </p>
      }
    >
      <AlertMessage msg={error ? { type: 'error', text: error } : null} />

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="label">Email</label>
          <input
            type="email"
            className="input"
            placeholder="email@example.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            autoComplete="email"
            required
          />
          <p className="text-xs text-gray-600 mt-2">
            The email address you used when you registered.
          </p>
        </div>
        <button type="submit" className="btn-primary w-full py-3" disabled={loading}>
          {loading ? 'Sending link…' : 'Send reset link'}
        </button>
      </form>
    </AuthShell>
  );
}
